import { StatusBadge } from "@components";
import { Text } from "@pentabd/ui";
import dayjs from "dayjs";
import { TFunction } from "i18next";

export const AssetsListTableColumn = (
  t: TFunction<"translation", undefined>,
  language: string | null,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.NAME"),
      render: (name: string) => (
        <Text component="p" color="subtitle2">
          {name}
        </Text>
      ),
    },
    {
      id: 2,
      key: "category",
      name: t(
        "INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.CATEGORY",
      ),
      render: (category: string) => <Text color="subtitle2">{category}</Text>,
    },
    {
      id: 3,
      key: "group",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.GROUP"),
      render: (group: string) => <Text color="subtitle2">{group}</Text>,
    },
    {
      id: 4,
      key: "brand",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.BRAND"),
      render: (brand: string) => <Text color="subtitle2">{brand}</Text>,
    },
    {
      id: 5,
      key: "type",
      name: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.TYPE"),
      render: (type: string) => <Text color="subtitle2">{type}</Text>,
    },
    {
      id: 6,
      key: "amount",
      name: t(
        "INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.AMOUNT",
      ),
      render: (amount: number) => <Text color="subtitle2">{amount}</Text>,
    },
    {
      id: 7,
      key: "barCode",
      name: t(
        "INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.BARCODE",
      ),
      render: (barCode: number) => <Text color="subtitle2">{barCode}</Text>,
    },
    {
      id: 8,
      key: "condition",
      name: t(
        "INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.CONDITION",
      ),
      render: (condition: string) => <StatusBadge status={condition} />,
    },
    {
      id: 9,
      key: "assignedDate",
      name: t(
        "INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.ASSETS.TABLE.COLUMNS.ASSIGNED_DATE",
      ),
      render: (assignedDate: string) => (
        <Text color="subtitle2">
          {assignedDate && dayjs(assignedDate).format("DD/MM/YYYY")}
        </Text>
      ),
    },
  ];
};
